<template>
  <div>
    <nav class="top-nav">
      <div class="top-nav-inner">
        <!-- account button -->
        <button
          v-if="userDetails?.photoURL"
          @click="showAccountPopup"
          class="nav-btn avatar"
          :style="{ backgroundImage: 'url(' + userDetails?.photoURL + ')' }"
        >
          <div class="tooltip">Account</div>
        </button>
        <button v-else @click="showAccountPopup" class="nav-btn">
          <div class="tooltip">Account</div>
          <span class="material-icons-round btn-icon"> person </span>
        </button>

        <!-- title -->
        <router-link to="/" class="title-link"
          ><h1 class="page-title">
            <img src="/images/geogrid.svg" class="geogrid-logo" /> GeoGrid
          </h1></router-link
        >

        <!-- stats button & hamburger menu-->
        <div class="top-nav-right">
          <router-link to="/stats" class="nav-btn">
            <div class="tooltip">Statistics</div>
            <span class="material-icons-round btn-icon"> bar_chart </span>
          </router-link>
          <HamburgerMenu
            @showPrevBoardPopup="showPrevBoardPopup"
            @showTeuteufGamesPopup="showTeuteufGamesPopup"
            @showCategoryInfoPopup="showCategoryInfoPopup"
            @showGameInfoPopup="showGameInfoPopup"
          />
        </div>
      </div>
    </nav>

    <!-- Popups managed by the header -->
    <GameInfo v-if="isGameInfoPopup" @close="hideGameInfoPopup" />
    <categoryInfo
      v-if="isCategoryInfoPopup"
      :category-id="selectedCategoryId"
      @close="hideCategoryInfoPopup"
    />
    <prev-board-popup
      v-if="isPrevBoardPopup"
      @select-board="hidePrevBoardPopup"
      @close="hidePrevBoardPopup"
    />
    <TeuteufGames v-if="isTeuteufGamesPopup" @close="hideTeuteufGamesPopup" />
    <AccountPopup v-if="isAccountPopup" @close="hideAccountPopup" />
  </div>
</template>

<script>
  import { inject } from 'vue';
  import AccountPopup from '../AccountPopup.vue';
  import PrevBoardPopup from '../prevBoardPopup.vue';
  import GameInfo from '../gameInfo.vue';
  import categoryInfo from '../categoryAtlas/categoryAtlas.vue';
  import TeuteufGames from '../TeuteufGames.vue';
  import HamburgerMenu from './HamburgerMenu.vue';

  export default {
    name: 'AppHeader',
    components: {
      AccountPopup,
      PrevBoardPopup,
      GameInfo,
      categoryInfo,
      TeuteufGames,
      HamburgerMenu,
    },
    emits: ['open-category'],
    setup() {
      const userDetails = inject('userDetails');

      return {
        userDetails,
      };
    },
    data() {
      return {
        isGameInfoPopup: false,
        isCategoryInfoPopup: false,
        isTeuteufGamesPopup: false,
        isAccountPopup: false,
        isPrevBoardPopup: false,
        selectedCategoryId: null,
      };
    },
    methods: {
      // Show the previous board popup
      showPrevBoardPopup() {
        this.isPrevBoardPopup = true;
      },

      // Hide the previous board popup
      hidePrevBoardPopup() {
        this.isPrevBoardPopup = false;
      },

      // Show the Teuteuf Games popup
      showTeuteufGamesPopup() {
        this.isTeuteufGamesPopup = true;
      },

      // Hide the Teuteuf Games popup
      hideTeuteufGamesPopup() {
        this.isTeuteufGamesPopup = false;
      },

      // Show the game info popup
      showGameInfoPopup() {
        this.isGameInfoPopup = true;
      },

      // Hide the game info popup
      hideGameInfoPopup() {
        this.isGameInfoPopup = false;
      },

      // Show the category info popup
      showCategoryInfoPopup() {
        this.isCategoryInfoPopup = true;
      },
      showCategoryInfoPopupWithCategory(categoryId) {
        this.isCategoryInfoPopup = true;
        this.selectedCategoryId = categoryId;
      },

      // Hide the category info popup
      hideCategoryInfoPopup() {
        this.isCategoryInfoPopup = false;
      },

      // Show the account popup
      showAccountPopup() {
        this.isAccountPopup = true;
      },

      // Hide the account popup
      hideAccountPopup() {
        this.isAccountPopup = false;
      },
    },
  };
</script>

<style scoped>
  .top-nav {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: column;
    z-index: 100;
    background-color: rgba(42, 42, 58, 1);
    line-height: 1;
    position: relative;
    margin-bottom: 32px;
  }

  .top-nav-inner {
    width: 100%;
    max-width: 812px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    padding: 16px;
    position: relative;
    justify-content: space-between;
    height: 80px;
    box-sizing: border-box;
  }

  .top-nav-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
  }

  .title-link {
    text-decoration: none;
    text-align: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    flex: 0 0 auto;
  }

  .page-title {
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin: 0;
  }

  .nav-btn {
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 8px;
    background-color: rgba(76, 76, 103, 1);
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }

  .nav-btn:hover {
    background-color: rgba(42, 42, 58, 1);
  }

  .btn-icon {
    font-size: 24px;
    color: rgba(173, 173, 234, 1);
  }

  .nav-btn.avatar {
    width: 40px;
    background-size: cover;
    background-position: center;
  }

  .tooltip {
    position: absolute;
    bottom: -36px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(32, 32, 44, 1);
    color: #fff;
    padding: 5px 10px;
    border-radius: 12px;
    white-space: nowrap;
    z-index: 1000;
    opacity: 0;
    transition: opacity 0.4s;
    pointer-events: none;
    font-size: 12px;
  }

  .nav-btn:hover .tooltip {
    opacity: 1;
  }

  .geogrid-logo {
    height: 30px;
  }

  @media screen and (max-width: 768px) {
    .page-title {
      font-size: 24px;
    }

    .geogrid-logo {
      height: 24px;
    }

    .top-nav {
      margin-bottom: 16px;
    }
  }
</style>
